"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../api/api");
var GetConfig = (function () {
    function GetConfig() {
        this.api = new api_1.default(window['API_URL'] + '/fast-coin');
    }
    GetConfig.prototype.getConfig = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.api.send('/get-config', {}, function (response) {
                resolve(response);
            }, function (err) {
                console.log('GetConfig failed.' + JSON.parse(err));
                reject(reject);
            });
        });
    };
    return GetConfig;
}());
exports.default = GetConfig;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/get-config/get-config.ts
// module id = 2395
// module chunks = 5